import React from 'react';
import { useEffect } from 'react';
import styles from './PoliticaPrivacidad.module.css';
import Footer from '../Home/Footer/Footer';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <h1 className={styles.title}>Políticas de Privacidad</h1>
        
        <div className={styles.policyCard}>
          <div className={styles.dateInfo}>
            <p>
              <strong>Fecha de entrada en vigor:</strong> 21 de noviembre de 2024<br />
              <strong>Última actualización:</strong> 21 de noviembre de 2024
            </p>
          </div>

          <div className={styles.contentSection}>
            <p>
              <strong>RELATIVIDAD IA Soluciones con Inteligencia Artificial S.A.S.</strong>, empresa registrada en Ecuador (en adelante, "Relatividad IA"), se compromete a proteger la privacidad y confidencialidad de la información proporcionada por sus usuarios (en adelante, "Usuarios"). Este Contrato de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos los datos personales en relación con el uso de nuestros servicios y la Plataforma.
            </p>

            <div>
              <h2 className={styles.sectionTitle}>Datos Recopilados</h2>
              <p>Relatividad IA incorporará y procesará información personal necesaria para la prestación de sus servicios, como:</p>
              <ul className={styles.listSection}>
                <li>Datos de identificación: nombres y apellidos, cédula/RUC, correo electrónico, número de teléfono.</li>
                <li>Datos financieros: información de tarjetas de crédito/debito.</li>
                <li>Datos técnicos: direcciones IP, cookies y datos de uso de la plataforma.</li>
              </ul>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Uso de Datos</h2>
              <p>Los datos recopilados serán utilizados para:</p>
              <ul className={styles.listSection}>
                <li>Procesar transacciones y pagos asociados a nuestros servicios.</li>
                <li>Mejorar la experiencia del Usuario y optimizar el rendimiento de nuestros productos haciendo estos personalizados a la necesidad de cada Usuario.</li>
                <li>Cumplir con obligaciones legales y fiscales conforme a la legislación ecuatoriana.</li>
                <li>Ofrecer soporte técnico y atención personalizada.</li>
              </ul>
            </div>

            <p className={styles.noteSection}>
              <strong>NOTA:</strong> RELATIVIDAD IA no comercializará, ni compartirá datos personales a usuarios no autorizados. Los datos recopilados son de uso exclusivo de RELATIVIDAD IA.
            </p>

            <div>
              <h2 className={styles.sectionTitle}>Medidas de Seguridad</h2>
              <p>Relatividad IA implementa medidas de seguridad administrativas, técnicas y físicas para proteger los datos personales frente a accesos no autorizados, pérdidas o alteraciones, incluyendo:</p>
              <ul className={styles.listSection}>
                <li>Encriptación de datos sensibles durante la transmisión.</li>
                <li>Accesos controlados a nuestras bases de datos.</li>
                <li>Monitoreo continuo de la seguridad de la Plataforma.</li>
              </ul>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Derechos del Usuario</h2>
              <p>El Usuario tiene derecho a:</p>
              <ul className={styles.listSection}>
                <li>Acceder, rectificar, actualizar o eliminar sus datos personales.</li>
                <li>Solicitar la limitación del tratamiento de sus datos.</li>
                <li>Retirar el consentimiento otorgado para el uso de sus datos, sin que esto afecte la legalidad del uso previo.</li>
              </ul>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Contacto</h2>
              <p>Para ejercer estos derechos, el Usuario puede contactar a Relatividad IA a través de:</p>
              <ul className={styles.listSection}>
                <li>Correo: <a href="mailto:legal@relatividadia.com" className={styles.contactLink}>legal@relatividadia.com</a></li>
                <li>Teléfono: <a href="tel:+593995772424" className={styles.contactLink}>099 577 2424</a></li>
              </ul>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Conservación de Datos</h2>
              <p>Los datos serán conservados únicamente durante el tiempo necesario para los fines descritos, salvo disposición legal que exija un período mayor.</p>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Modificaciones al Contrato</h2>
              <p>Relatividad IA se reserva el derecho de modificar este Contrato de Privacidad, notificando a los Usuarios a través de <a href="mailto:soporte@relatividadia.com" className={styles.contactLink}>soporte@relatividadia.com</a>. El uso continuado de nuestros servicios implica la aceptación de dichas modificaciones.</p>
            </div>

            <div className={styles.legalNotice}>
              <h2 className={styles.sectionTitle}>Jurisdicción</h2>
              <p>Este Contrato de Privacidad se rige por las leyes de Ecuador. En caso de controversias, las partes se someten a los tribunales competentes de Quito, Pichincha.</p>
            </div>

          </div>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default PrivacyPolicy;